import React from 'react'
import Link from 'next/link'
import { NewsArticle } from 'src/models'
import { Button } from 'src/360ui/Button'
import { newsArticlesRoute } from 'src/consts'
import { NewArticleElement } from '../LastNewsArticle'
import styles from './styles.module.scss'
import { useAppIntl } from 'src/i18n'

type Props = {
  className?: string
  newsArticles: NewsArticle
}

export const LastNewArticles = ({ className, newsArticles }: Props) => {
  const intl = useAppIntl()

  return (
    <div className={className}>
      <h2 className={styles.title}>{intl.t('newsArticle.latest.title')}</h2>
      {newsArticles.map(article => (
        <NewArticleElement key={article.id} newsArticle={article} />
      ))}
      <Button
        variant='tertiary'
        elementType={NextLink}
        href={newsArticlesRoute()}
        className={styles.viewAll}
      >
        {intl.t('newsArticle.latest.all')}
      </Button>
    </div>
  )
}

const NextLink = props => {
  return (
    <Link prefetch={false} {...props} legacyBehavior>
      <a className={props.className}>{props.children}</a>
    </Link>
  )
}
